import React, { ReactNode } from 'react'

interface IRegionProps {
  children?: ReactNode
}

const REGION_STYLES = 'pt-2 pr-10 pb-4 pl-10'

export const Region: React.FC<IRegionProps> = ({ children }) => (
  <div className={REGION_STYLES}>{children}</div>
)

Region.displayName = 'Content.Region'
